import { Channel, ChannelPayloadFilter } from 'spyne';
export class ChannelCodeblock extends Channel {
  constructor(name, props = {}) {
    name = 'CHANNEL_CODEBLOCK';
    props.sendCachedPayload = false;
    super(name, props);
  }

  onRegistered() {
    const copyBtnFilter = new ChannelPayloadFilter(".codeblock__copy", {
      action: "CHANNEL_UI_CLICK_EVENT",

    })

    this.getChannel("CHANNEL_UI", copyBtnFilter)
      .subscribe(this.onCopyBtnClicked.bind(this));

  }

  async onCopyBtnClicked(e){
    const {srcElement, event} = e;

    const {target} = event;
    const codeEl = target.closest('.codeblock').querySelector('code');

    const code = codeEl?.textContent ?? '';
    try {
      await navigator.clipboard.writeText(code);
      target.textContent = 'Copied';
    } catch {
      target.textContent = 'Failed';
    }
    setTimeout(() => (target.textContent = 'Copy'), 1500);

    console.log('copy btn clicked ',{codeEl, target, event, srcElement,e});

  }

  addRegisteredActions() {
    return [
      'CHANNEL_CODEBLOCK_COPY_EVENT'
    ];
  }

  onViewStreamInfo() {}
}
